<div
  #mobileToolbar
  class="h-16 flex items-end pb-2 space-x-8 font-header font-(--font-weight-header)"
>
  <app-search-input
    class="w-2xs h-10 flex"
    placeholder="Search..."
    [value]="filteringService.search()"
  />

  <button
    type="button"
    (click)="openFiltersModal()"
    class="rounded-md ml-auto px-3 py-2 text-sm text-gray-100 h-10 items-center flex flex-row gap-2 cursor-pointer transition-all duration-100 bg-white/10 ring-1 ring-inset ring-white/20 hover:bg-white/20 hover:ring-white/30 active:bg-white active:text-primary-700 active:ring-primary-200/60 active:shadow-inner focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/40 aria-pressed:bg-white aria-pressed:text-primary-700 aria-pressed:ring-primary-200/60 aria-pressed:shadow-inner hover:aria-pressed:bg-white/90"
    [attr.aria-pressed]="stateService.isFiltersModalOpen()"
    aria-haspopup="dialog"
  >
    <svg height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor">
      <path
        d="M440-120v-240h80v80h320v80H520v80h-80Zm-320-80v-80h240v80H120Zm160-160v-80H120v-80h160v-80h80v240h-80Zm160-80v-80h400v80H440Zm160-160v-240h80v80h160v80H680v80h-80Zm-480-80v-80h400v80H120Z"
      />
    </svg>

    <span class="hidden sm:inline-block">Filters</span>

    @if (filteringService.hasFilters()) {
      <span
        class="size-2 rounded-full bg-villages-gold-500 shrink-0"
        aria-label="Filters active"
      ></span>
    }
  </button>
</div>

<div class="h-16 flex items-start pt-2 gap-3 sm:gap-8 font-header font-(--font-weight-header)">
  <button
    type="button"
    (click)="modelGalleryClicked.emit()"
    class="rounded-md px-3 py-2 text-sm text-gray-100 h-10 items-center flex flex-row gap-2 cursor-pointer transition-all duration-100 bg-white/10 ring-1 ring-inset ring-white/20 hover:bg-white/20 hover:ring-white/30 active:bg-white active:text-primary-700 active:ring-primary-200/60 active:shadow-inner focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/40"
  >
    <svg height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor">
      <path
        d="M80-160v-400l240-240 240 240v400H80Zm80-80h120v-120h80v120h120v-287L320-687 160-527v287Zm120-200v-80h80v80h-80Zm360 280v-433L433-800h113l174 174v466h-80Zm160 0v-499L659-800h113l108 108v532h-80Zm-640-80h320-320Z"
      />
    </svg>

    <span class="hidden sm:inline-block whitespace-nowrap">Model Gallery</span>
  </button>

  <button
    type="button"
    class="group rounded-md px-3 py-2 text-sm text-gray-100 h-10 items-center flex flex-row gap-2 cursor-pointer transition-all duration-100 bg-white/10 ring-1 ring-inset ring-white/20 hover:bg-white/20 hover:ring-white/30 active:bg-white active:text-primary-700 active:ring-primary-200/60 active:shadow-inner focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/40 aria-pressed:bg-white aria-pressed:text-primary-700 aria-pressed:ring-1 aria-pressed:ring-inset aria-pressed:ring-primary-200/60 aria-pressed:shadow-inner hover:aria-pressed:bg-white/90"
    [attr.aria-label]="filteringService.dreamHomes() ? 'Dream Homes active' : 'Show Dream Homes'"
    [attr.aria-pressed]="filteringService.dreamHomes()"
    (click)="toggleDreamHomes()"
  >
    <svg
      viewBox="0 -960 960 960"
      class="h-5 w-5 transition-colors fill-white group-aria-pressed:fill-red-500"
      aria-hidden="true"
    >
      <path
        d="m480-147.69-44.15-40.39Q336-278.23 264.31-349.35q-71.7-71.11-114.96-126.19-43.27-55.07-56.31-99.96Q80-620.38 80-665.23q0-92 61.5-153.38Q203-880 295.38-880q55 0 102.31 26.5Q445-827 480-778.46 515-827 562.31-853.5q47.31-26.5 102.31-26.5 91.84 0 153.61 61.39Q880-757.22 880-665.23q0 44.85-13.04 89.73-13.04 44.89-56.31 99.96-43.26 55.08-114.76 126.19-71.5 71.12-171.36 161.27L480-147.69Z"
      />
    </svg>

    <span class="hidden sm:flex gap-2">
      <span class="whitespace-nowrap">Dream Homes</span>

      @if (listingsService.savedListingsAvailableCount()) {
        <span
          class="inline-flex items-center rounded-full bg-primary-300 group-aria-pressed:bg-primary-100 group-aria-pressed:text-primary-600 px-2 py-1 text-xs font-medium text-white inset-ring inset-ring-gray-500/10"
        >
          {{ listingsService.savedListingsAvailableCount() }}
        </span>
      }
    </span>
  </button>

  <button
    type="button"
    (click)="toggleSaveSearch()"
    class="rounded-md px-3 py-2 text-sm text-gray-100 h-10 items-center flex flex-row gap-2 cursor-pointer transition-all duration-100 bg-white/10 ring-1 ring-inset ring-white/20 hover:bg-white/20 hover:ring-white/30 active:bg-white active:text-primary-700 active:ring-primary-200/60 active:shadow-inner focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/40"
    [attr.aria-expanded]="saveSearchOpen()"
    aria-haspopup="dialog"
  >
    <svg class="h-5 w-5 shrink-0" viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true">
      <path
        d="M200-120v-640q0-33 23.5-56.5T280-840h400q33 0 56.5 23.5T760-760v640L480-240 200-120Zm80-122 200-86 200 86v-518H280v518Zm0-518h400-400Z"
      />
    </svg>
    <span class="hidden sm:inline whitespace-nowrap">Save Search</span>
  </button>

  @if (saveSearchOpen()) {
    <div
      class="fixed inset-0 z-55 bg-black/50"
      (click)="saveSearchOpen.set(false)"
      aria-hidden="true"
    ></div>
    <div
      class="fixed bottom-0 left-0 right-0 rounded-t-2xl bg-white dark:bg-gray-800 shadow-xl z-60 flex flex-col max-h-[80vh] pb-[calc(env(safe-area-inset-bottom)+10rem)]"
      role="dialog"
      aria-modal="true"
      aria-label="Save Search"
    >
      <div class="grid grid-cols-[1fr_auto_1fr] items-center px-4 pt-3 pb-2 shrink-0">
        <div></div>
        <div class="h-1.5 w-12 rounded-full bg-gray-300 dark:bg-gray-600" aria-hidden="true"></div>
        <div class="flex justify-end">
          <button
            type="button"
            (click)="saveSearchOpen.set(false)"
            class="rounded-full p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:text-gray-200 dark:hover:bg-white/10 transition-colors focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-gray-400 cursor-pointer"
            aria-label="Close"
          >
            <svg class="size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path
                d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z"
              />
            </svg>
          </button>
        </div>
      </div>
      <div class="overflow-y-auto px-5 pb-40">
        <app-filters-saved class="flex flex-col gap-2" />
      </div>
    </div>
  }

  <button
    type="button"
    class="rounded-md ml-auto px-3 py-2 text-sm text-gray-100 h-10 items-center cursor-pointer transition-all duration-100 bg-white/10 ring-1 ring-inset ring-white/20 hover:bg-white/20 hover:ring-white/30 active:bg-white active:text-primary-700 active:ring-primary-200/60 active:shadow-inner focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/40"
    (click)="stateService.mobileMapView.set(!stateService.mobileMapView())"
  >
    {{ stateService.mobileMapView() ? 'List' : 'Map' }}
  </button>
</div>
